import BaseTable from 'components/Tables/BaseTable';
import { sortBy } from 'lodash';
import FlowListDetailPanel from 'pages/ScenarioExposure/Flow/ScenariosManagement/FlowListDetailPanel';
import React, { useRef } from 'react';
import { connect } from 'react-redux';
import theme from 'source/theme';
import tableIcons from 'utils/icons/materialTableIcons';
import columns from 'utils/tables/columns/scenarioExposure/flow/flowPcSuScenarioDescriptorExposure';

const Component = props => {
  const {
    descriptorId, descriptorsById, descriptorsData, descriptorFilter, scenariosById,
    flowScenarioDescriptors, flowsById, TABLE_HEIGHT
  } = props;

  const { setDescriptorId } = props;
  const tableRef = useRef();

  const filteredDescriptors = descriptorsData.filter(v => v.descriptor_type_id === descriptorFilter);
  const filteredDescriptorsIds = filteredDescriptors.map(fD => fD.id);
  const filteredSD = flowScenarioDescriptors.filter(fSD => filteredDescriptorsIds.includes(fSD.descriptor_id));

  const mergedProductDescriptors = [];
  const descriptorRepetitions = [];

  filteredSD.forEach(fSD => {
    if (!descriptorRepetitions.includes(fSD.descriptor_id)) {
      const scenariodescriptorGrouped = filteredSD.filter(item => item.descriptor_id === fSD.descriptor_id);
      const mergedDescriptor = {
        id: fSD.descriptor_id,
        descriptor_code: descriptorsById[fSD.descriptor_id].code,
        descriptor_description: descriptorsById[fSD.descriptor_id].description,
        flowsInfo: []
      };

      const repeatedFlows = [];
      scenariodescriptorGrouped.forEach(sdg => {
        const flow = flowsById[scenariosById[sdg.scenario_id].flow_id];
        if (!repeatedFlows.includes(flow.id)) {
          mergedDescriptor.flowsInfo.push({
            code: flow.code,
            name: flow.name
          });
          repeatedFlows.push(flow.id);
        }
      });

      descriptorRepetitions.push(fSD.descriptor_id);
      mergedProductDescriptors.push(mergedDescriptor);
    }
  });

  const rows = sortBy(mergedProductDescriptors, ['id']);

  return (
    <React.Fragment>
      <BaseTable
        ref={tableRef}
        title={'DESCRITORES DO FLUXO'}
        columns={columns}
        data={rows}
        order={false}
        paging={false}
        onRowClick={() => null}
        onRowDoubleClick={setDescriptorId ? rowData => setDescriptorId(rowData.id) : null}
        options={{
          // toolbar: false,
          // search: false,
          maxBodyHeight: TABLE_HEIGHT,
          minBodyHeight: TABLE_HEIGHT,
          rowStyle: setDescriptorId ? rowData => ({
              backgroundColor: (rowData.id === descriptorId) ?
                theme.palette.primary.light :
                theme.palette.background.veryLight
            }) :
            ({ backgroundColor: theme.palette.background.veryLight })
        }}
        detailPanel={[
          () => ({
            icon: tableIcons.Flow,
            tooltip: 'Fluxogramas',
            render: ({ rowData }) => <FlowListDetailPanel row={rowData}/>
          })
        ]}
      />
    </React.Fragment>
  );
};


const mapStateToProps = (state) => ({
  descriptorsData: state.descriptors.data,
  descriptorsById: state.descriptors.models,
  scenariosById: state.scenarios.models,
  flowsById: state.flows.models
});

export default connect(mapStateToProps)(Component);
